import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

enum emptyContentSize {
  Default = 'Default',
  Small = 'Small'
}

@Component({
  selector: 'pcs-empty-content',
  templateUrl: './empty-content.component.html',
  styleUrls: ['./empty-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyContentComponent {
  @Input() message = '';
  @Input() icon = '';
  @Input() emptyContentSize = emptyContentSize.Default;

  @HostBinding('class.small-content')
  private get isSmall() {
    return this.emptyContentSize === emptyContentSize.Small;
  }
}
